module.exports = __webpack_public_path__ + "img/full2-min.16b6f8da.png";